import React from 'react'
import Link from 'gatsby-link'

import logo3 from '../images/home_logo3.png'
import twitter from '../images/twitter.png'
import rss from '../images/rss.png'
import facebook from '../images/facebook.png'
import linkedin from '../images/linkedin.png'



function Footer() {
    return (
        <div className="footer-container">
            <div className="column1">
                <a href="/"><img className="logo"  alt="logo" src={logo3} /></a>
                <a href="https://twitter.com/beneticinc" target="_blank"><img className="logo1" alt="twitter" src={twitter} /></a>
                <a href="" target="_blank"><img className="logo2" alt="rss" src={rss} /></a>
                <a href="https://www.facebook.com/Benetic-Inc-100640304811333/" target="_blank"><img className="logo3" alt="facebook" src={facebook} /></a>
                <a href="https://www.linkedin.com/company/benetic/" target="_blank"><img className="logo4" alt="linkedin" src={linkedin} /></a>
            </div>
            <div className="column2">
                <Link style={{color: "white"}} to="/platform">Platform</Link>
            </div>
            <div className="column3">
                <Link className="solutions" to="/advisors">Solutions</Link>
                <Link className="solution1" to="/advisors">Advisors</Link>
                <Link className="solution2" to="/asset-managers">Asset Managers</Link>
                <Link className="solution3" to="/recordkeepers">Recordkeepers</Link>
            </div>
            <div className="column4">
                <Link style={{color: "white"}} to="/">Company</Link>
            </div>
            <div className="column5">
                <Link style={{color: "white"}} to="/">Resources</Link>
            </div>
            
            <p className="bottom-text1">Benetic, Inc. ©2020 | Privacy Policy</p>
            <p className="bottom-text2">Benetic and Benetic Marketplace are trademarks of Benetic, Inc.</p>
        </div>
  )
}

export default Footer